import React, { FC } from "react";
import { Link } from "react-router-dom";
import { mdiMenuRight } from "@mdi/js";
import Icon from "@mdi/react";
import { City, Location } from "../../interfaces/country.interface";

interface PostcardProps {
  link: string;
  image: string | undefined;
  name: string;
  tourCount: number | undefined;
}

const Postcard: FC<PostcardProps> = ( {tourCount = 0, link, image, name}) => {

  const pluralize = (count: number, noun: string, suffix = 's') =>
    `${count} ${noun}${count > 1 ? suffix : ''}`;

  return (
    <Link to={link} className="postcard">
      <img src={image}/>
      <div className="details">
        <span className="name">{name}</span>
        <span className="tour-count">{pluralize(tourCount, "Tour")} <Icon path={mdiMenuRight} size={1} /> </span>
      </div>
    </Link>
  )
}

const LocationPostcards = (
  props: {
    locations:Location[];
    listingLink;
  }
) => {
  const { listingLink, locations } = props;

  return (
    <div className="postcards">
      {
        locations.map((city:City, index)=><Postcard key={index} link={listingLink(city)} image={city.cover} name={city.name} tourCount={city.tourCount}/>)
      }
    </div>
  )
}

LocationPostcards.defaultProps = {
  locations: []
}

export default LocationPostcards;